import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { StatusLead } from "../pages/StatusLead/StatusLead";

const OUTAPP_PATHS = ["/status-lead"];

export function OutApp({ children }: { children: JSX.Element }): JSX.Element {
  const location = useLocation();

  if (OUTAPP_PATHS.includes(location.pathname)) {
    return (
      <Routes>
        <Route path="/status-lead" element={<StatusLead />} />
        <Route path="*" element={<Navigate to="/not-found" replace />} />
      </Routes>
    );
  }

  return children;
}
